import './bootstrap'
import './mixins' // vue mixins
import store from './vuex'

import LazyLoad from 'vanilla-lazyload'

import './scripts/navigation.js'
import './scripts/web_lang.js'

//lazy loading
$(document).ready(function() {
    new LazyLoad({
        elements_selector: '.lazy'
    })
})

Vue.component('SvgIcon', () => import('./components/SvgIcon.vue').default)
Vue.component('ProgressBar', () => import('./components/ProgressBar.vue'))
Vue.component('FormInputTypePhoneNumber', require('./components/_Form/Input/Type/PhoneNumber.vue').default)
Vue.component('FormInputTypeEmail', require('./components/_Form/Input/Type/Email.vue').default)
Vue.component('FormInputTypePassword', require('./components/_Form/Input/Type/Password.vue').default)
Vue.component('FormInputTypeText', require('./components/_Form/Input/Type/Text.vue').default)
Vue.component('FormInputError', require('./components/_Form/Input/Error.vue').default)
Vue.component('FormInputTypeTextArea', require('./components/_Form/Input/Type/TextArea.vue').default)
Vue.component('FormInputTypeSelect', require('./components/_Form/Input/Type/Select.vue').default)
Vue.component('FormInputTypeCheckbox', require('./components/_Form/Input/Type/Checkbox.vue').default)
Vue.component('FormInputTypeToggle', require('./components/_Form/Input/Type/Toggle.vue').default)
Vue.component('FormInputUploadFile', require('./components/_Form/Input/Type/UploadFile.vue').default)
Vue.component('FormInputTypeRadio', require('./components/_Form/Input/Type/Radio.vue').default)
Vue.component('FormInputTypeUploadFile', require('./components/_Form/Input/Type/UploadFile.vue').default)
Vue.component('FormInputNote', require('./components/_Form/Input/Note.vue').default)
Vue.component('FormInputTypeDatepicker', require('./components/_Form/Input/Type/Datepicker.vue').default)
Vue.component('VButton', require('./components/VButton.vue').default)
Vue.component('DownloadAppBtn', require('./components/Web/DownloadAppBtn.vue').default)
Vue.component('ContactForm', () => import('./components/FormsWeb/ContactForm.vue'))
Vue.component('RecruitForm', () => import('./components/FormsWeb/RecruitForm.vue'))
Vue.component('ContactFormBusiness', () => import('./components/FormsWeb/ContactFormBusiness.vue'))
Vue.component('FormDownloadApp', () => import('./components/FormsWeb/FormDownloadApp.vue'))
Vue.component('FormVerifyEmail', () => import('./components/FormsWeb/FormVerifyEmail.vue'))
Vue.component('FlashAlert', () => import('./components/FlashAlert.vue'))
Vue.component('DiabetesKnowledgeCategories', () => import('./components/Web/DiabetesKnowledgeCategories.vue'))
Vue.component('DiabetesKnowledgePosts', () => import('./components/Web/DiabetesKnowledgePosts.vue'))
Vue.component('QuizDiabetesManagment', () => import('./components/Web/QuizDiabetesManagment.vue'))
Vue.component('QuizDiabetesManagmentLast', () => import('./components/Web/QuizDiabetesManagmentLast.vue'))
Vue.component('DiabetesRiskCheckQuiz', () => import('./components/Web/DiabetesRiskCheckQuiz.vue'))
Vue.component('PrescriptionForm', () => import('./components/FormsWeb/PrescriptionForm.vue'))
Vue.component('SearchInsuranceCompanyForm', () => import('./components/FormsWeb/SearchInsuranceCompanyForm.vue'))
Vue.component('DoctorForm', () => import('./components/FormsWeb/DoctorForm.vue'))
Vue.component('DoctorFormIt', () => import('./components/FormsWeb/DoctorFormIT.vue'))
Vue.component('DoctorFormSuccess', () => import('./components/FormsWeb/DoctorFormSuccess.vue'))
Vue.component('CallModal', () => import('./components/Web/CallModal.vue'))
Vue.component('OnboardingMainTemplateTypeA', () => import('./components/Web/OnboardingDeTypeA/OnboardingMainTemplate.vue'))
Vue.component('OnboardingMainTemplateTypeB', () => import('./components/Web/OnboardingDeTypeB/OnboardingMainTemplate.vue'))
Vue.component('OnboardingMainTemplateDeNew', () => import('./components/Web/OnboardingDeNew/OnboardingMainTemplate.vue'))
Vue.component('StudyQuizMainTemplate', () => import('./components/Web/StudyQuiz/StudyQuizMainTemplate.vue'))
Vue.component('FormInputTypeRadioButton', require('./components/_Form/Input/Type/RadioButton.vue').default)
Vue.component('FormInputTypeRadioButtonBoolean', require('./components/_Form/Input/Type/RadioButtonBoolean.vue').default)
Vue.component('ViviraCodeForm', () => import('./components/FormsWeb/ViviraCodeForm.vue'))
Vue.component('MilionaireConsultationForm', () => import('./components/FormsWeb/MilionaireConsultationForm.vue'))
Vue.component('ResubscriptionFeedback', () => import('./components/Web/ResubscriptionFeedback.vue'))
Vue.component('CareerEn', () => import('./components/Web/WebEn/Career.vue'))
Vue.component('OpenPositionsDetail', () => import('./components/Web/WebEn/OpenPositionsDetail.vue'))
Vue.component('VitadioLife', () => import('./components/Web/Socials/InstagramVitadioLife.vue'))
Vue.component('Locket', () => import('./components/Web/Locket.vue'))
Vue.component('NavbarWebdemo', () => import('./components/Web/WebDemoDoctors/Navbar.vue'))
Vue.component('AppStepTemplate', () => import('./components/Web/WebDemoDoctors/AppStepTemplate.vue'))
Vue.component('MobileTemplate', () => import('./components/Web/WebDemoDoctors/MobileTemplate.vue'))
Vue.component('NotificationBar', () => import('./components/Web/NotificationBar.vue'))
Vue.component('WebModal', require('./components/WebModal.vue').default)
Vue.component('OnboardingMainTemplateIt', () => import('./components/Web/OnboardingIT/OnboardingMainTemplate.vue'))
Vue.component('ContactCallForm', () => import('./components/FormsWeb/ContactCallForm.vue'))
Vue.component('CallSuccess', () => import('./components/FormsWeb/CallSuccess.vue'))
Vue.component('LearntAboutVitadioForm', () => import('./components/FormsWeb/LearntAboutVitadioForm.vue'))
Vue.component('PrescriptionSuccess', () => import('./components/FormsWeb/PrescriptionSuccess.vue'))
Vue.component('CmeRegistrationForm', () => import('./components/FormsWeb/CmeRegistrationForm.vue'))

new Vue({
    el: '#app',
    store,
    data: {
        storeCompleted: false,
        tab: null
    },
    async mounted() {
        console.log(`
      ----------------------------------------
      ----------------Vitad.io----------------
      ----------------------------------------
              ${moment().format('Do MMMM YYYY, HH:mm:ss')}
    `)

        // Try to store currently logged in user into the store
        await store.commit('general/setUser')

        this.storeCompleted = true
    }
})
